module.exports = __webpack_public_path__ + "assets/img/kefupng.f75cdccc.png";